import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import './CreateBuilding.scss';
import { Button } from 'reactstrap';
import { 
  ParkingModel , 
  BuildingInformation, 
  RedemptionModelInformation, 
  ConfigCommon,
  Config, 
  BuildingContent, 
  BuildingTenant, 
  BuildingIotDevice,
  BuildingParkingDayConfig,
  Loading,
} from '../../components';
import { 
  fetchCreateDraftBuilding, 
  fetchGetDraftBuilding,
  setBuildingInformation,
  setBuildingParkingFeeModelCar,
  setBuildingParkingFeeModelMotorcycle,
  setRedemptionModelInformation,
  setConfigCommon,
  setConfig,
  setBuildingContent,
  setBuildingTenant,
  setBuildingIotDevice,
  setBuildingParkingDayConfig,
  fetchCreateBuilding,
} from '../../actions';
import { history, Modal, passParamsToPath } from '../../helpers';
import commonConstant from '../../common/_commonConstant';

class CreateBuilding extends Component {
  constructor(props) {
    super(props);
    this.state = {
      'section': 'building-information',
      'loading': false,
      'willOnBoard' : false,
      'showOnboardModal' : false,
    };
  }

  componentDidMount() {
    if (this.props.match.path === commonConstant.pathEditDraftedBuilding) {
      this.props.dispatch(fetchGetDraftBuilding(this.props.match.params.draftedBuildingID));
      this.setState({
        'loading' : true,
      });
    } else if (this.props.match.path === commonConstant.pathCreateBuilding) {      
      this.handleClearData();
    }
  }
  UNSAFE_componentWillReceiveProps(nextProps) {
    const { createDraftBuilding } = this.props;
    const { willOnBoard } = this.state;

    if (nextProps.createDraftBuilding && nextProps.createDraftBuilding !== createDraftBuilding) {
      if (nextProps.createDraftBuilding.status === 200) {        
        if (willOnBoard && this.props.match.path === commonConstant.pathEditDraftedBuilding) {
          this.handleDispatchOnboardBuilding(this.props.match.params.draftedBuildingID);
        } else if (willOnBoard && this.props.match.path === commonConstant.pathCreateBuilding) {
          this.handleDispatchOnboardBuilding(nextProps.createDraftBuilding.data.draftedBuildingID);
        } else if (!willOnBoard && this.props.match.path === commonConstant.pathCreateBuilding) {
          history.push(passParamsToPath(commonConstant.pathEditDraftedBuilding, { 'draftedBuildingID': nextProps.createDraftBuilding.data.draftedBuildingID }));
        }      
        // return this.setState({ 'loading': false });
      } else if (nextProps.createDraftBuilding.status === 400) {
        if (willOnBoard) {
          this.setState({
            'willOnBoard' : false,
          });
        }
      }
      if (!willOnBoard) {
        return this.setState({ 'loading': false });
      }
    } 
  }

  componentDidUpdate(prevProps) {
    const { getDraftBuilding, createBuilding } = this.props;

    if (getDraftBuilding.status === 200 && getDraftBuilding.type === commonConstant.GET_DRAFT_BUILDING_SUCCESS && prevProps.getDraftBuilding != getDraftBuilding) {
      this.handleMappingData();
    } else if (createBuilding.status === 200 && createBuilding.type === commonConstant.CREATE_BUILDING_SUCCESS && prevProps.createBuilding != createBuilding) {
      this.setState({
        'loading' : false,
      });
      history.push(commonConstant.pathSelectBuilding);
    }
  }

  handleClearData = () => {
    this.setState({
      'section': 'building-information',
      'loading': false,
      'willOnBoard' : false,
    });
  }

  handleIsCanOnboard = () => {
    const { 
      buildingInformation, buildingParkingFeeModelCar, buildingParkingFeeModelMotorcycle, 
      redemptionModelInformation, configCommon, config, buildingContent, buildingTenant,
      buildingIotDevice, buildingParkingDayConfig,
    } = this.props;
      
    const propertiesToCheck = [
      buildingInformation, buildingParkingFeeModelCar, buildingParkingFeeModelMotorcycle, 
      redemptionModelInformation, configCommon, config, buildingContent, buildingTenant,
      buildingIotDevice, buildingParkingDayConfig,
    ];
  
    const canSave = propertiesToCheck.every(property => property.data && property.data.isCanSave);
    
    if (canSave) {
      return true;
    } else {
      return false;
    }
  }

  handleOnboardBuilding = () => {
    this.handleSaveDraftData(); 
    this.setState({
      'willOnBoard' : true,
    });   
  }

  handleDispatchOnboardBuilding = (draftedBuildingID) => {
    this.setState({
      'loading' : true,
    });

    this.props.dispatch(fetchCreateBuilding(draftedBuildingID));
  }

  handleMappingData = () => {
    const { getDraftBuilding } = this.props;
    const draftBuildingData = getDraftBuilding.data[0].importDataDraftedBuilding;
    if (draftBuildingData.building) {
      this.props.dispatch(setBuildingInformation(
        draftBuildingData.building,
      ));
    }
    if (draftBuildingData.buildingParkingFeeModelCar) {
      this.props.dispatch(setBuildingParkingFeeModelCar(
        {
          ...draftBuildingData.buildingParkingFeeModelCar,
          'isCanSave' : true,
        },        
      ));
    }
    if (draftBuildingData.buildingParkingFeeModelMotorcycle) {
      this.props.dispatch(setBuildingParkingFeeModelMotorcycle(
        {
          ...draftBuildingData.buildingParkingFeeModelMotorcycle,
          'isCanSave' : true,
        },        
      ));
    }
    if (draftBuildingData.buildingRedemptionModelCar && draftBuildingData.buildingRedemptionModelMotorcycle) {
      this.props.dispatch(setRedemptionModelInformation(
        {
          'maximumRedemptionMinutesCar' : draftBuildingData.buildingRedemptionModelCar.maximumRedemptionMinutes,
          'maximumRedemptionQuotaCar' : draftBuildingData.buildingRedemptionModelCar.maximumRedemptionQuota,
          'maximumRedemptionMinutesMotorcycle' : draftBuildingData.buildingRedemptionModelMotorcycle.maximumRedemptionMinutes,
          'maximumRedemptionQuotaMotorcycle' : draftBuildingData.buildingRedemptionModelMotorcycle.maximumRedemptionQuota,
          'redemptionModelCar' : draftBuildingData.buildingRedemptionModelCar.redemptionModel,
          'redemptionModelMotorcycle' : draftBuildingData.buildingRedemptionModelMotorcycle.redemptionModel,
          'isCanSave' : true,
        },        
      ));
    }
    if (draftBuildingData.buildingConfigCommon){
      this.props.dispatch(setConfigCommon(
        {
          ...draftBuildingData.buildingConfigCommon,
          'isCanSave' : true,
        },
      ));
    }
    if (draftBuildingData.buildingConfigCar && draftBuildingData.buildingConfigMotorcycle){
      const carOvernightTimeStart = draftBuildingData.buildingConfigCar.overnightTimeStart ? this.handleSplitTime(draftBuildingData.buildingConfigCar.overnightTimeStart) : null; 
      const carOvernightTimeEnd = draftBuildingData.buildingConfigCar.overnightTimeEnd ? this.handleSplitTime(draftBuildingData.buildingConfigCar.overnightTimeEnd) : null;
      const motorcycleOvernightTimeStart = draftBuildingData.buildingConfigMotorcycle.overnightTimeStart ? this.handleSplitTime(draftBuildingData.buildingConfigMotorcycle.overnightTimeStart) : null;
      const motorcycleOvernightTimeEnd = draftBuildingData.buildingConfigMotorcycle.overnightTimeEnd ? this.handleSplitTime(draftBuildingData.buildingConfigMotorcycle.overnightTimeEnd) : null;
      
      this.props.dispatch(setConfig(
        {
          'buildingConfigCar' : {
            ...draftBuildingData.buildingConfigCar,
            'overnightTimeStart' : carOvernightTimeStart ? carOvernightTimeStart : null,
            'overnightTimeEnd' : carOvernightTimeEnd ? carOvernightTimeEnd : null,
          },
          'buildingConfigMotorcycle' : {
            ...draftBuildingData.buildingConfigMotorcycle,
            'overnightTimeStart' : motorcycleOvernightTimeStart ? motorcycleOvernightTimeStart : null,
            'overnightTimeEnd' : motorcycleOvernightTimeEnd ? motorcycleOvernightTimeEnd : null,
          },
          'isCanSave' : true,
        },        
      ));
    }
    if (draftBuildingData.buildingContentTH && draftBuildingData.buildingContentEN) {
      this.props.dispatch(setBuildingContent(
        {
          'buildingContentTH' : {
            ...draftBuildingData.buildingContentTH,
          }, 
          'buildingContentEN' : {
            ...draftBuildingData.buildingContentEN,
          },
          'isCanSave' : true,
        },
      ));
    }
    if (draftBuildingData.tenantMembers && draftBuildingData.tenants && (draftBuildingData.tenantMembers.length > 0 || draftBuildingData.tenants.length > 0)) {
      this.props.dispatch(setBuildingTenant(
        {
          'tenantMemberData' : draftBuildingData.tenantMembers,
          'tenantData' : draftBuildingData.tenants,
          'isCanSave' : true,
        },
      ));
    }
    if (draftBuildingData.buildingIotDevices && draftBuildingData.buildingIotDevices.length > 0) {        
      this.props.dispatch(setBuildingIotDevice(
        {
          'buildingIotDevices' : draftBuildingData.buildingIotDevices,
          'isCanSave' : true,
        },
      ));
    }
    if (draftBuildingData.buildingIotDevices && draftBuildingData.buildingIotDevices.length > 0 && draftBuildingData.parkingDayConfigs.length === 0){
      const setBuildingParkingDayConfigWeekday = [];
      const setBuildingParkingDayConfigWeekend = [];
      for (let zoneIndex = 0; zoneIndex < draftBuildingData.buildingIotDevices.length / 6; zoneIndex++) {
        const location = zoneIndex + 1 < 9 ? `0${zoneIndex + 1}` : `${zoneIndex + 1}`;
        setBuildingParkingDayConfigWeekday.push(
          {
            'parkingDayConfigDayType': 'WEEKDAY',          
            'parkingDayConfigParkingZone': `IN-${location}/OUT-${location}`,
            'parkingDayConfigAllowance': null,
            'parkingDayConfigChargeCustomer': null,
            'parkingDayConfigStartDatetime' : null,
            'parkingDayConfigEndDatetime' : null,
          },
        );
  
        setBuildingParkingDayConfigWeekend.push(
          {
            'parkingDayConfigDayType': 'WEEKEND',          
            'parkingDayConfigParkingZone': `IN-${location}/OUT-${location}`,
            'parkingDayConfigAllowance': null,
            'parkingDayConfigChargeCustomer': null,
            'parkingDayConfigStartDatetime' : null,
            'parkingDayConfigEndDatetime' : null,
          },
        );
      }

      this.props.dispatch(setBuildingParkingDayConfig({
        'parkingDayConfig' : [
          ...setBuildingParkingDayConfigWeekday,
          ...setBuildingParkingDayConfigWeekend,          
        ],
      }));
    } 

    if (draftBuildingData.parkingDayConfigs.length > 0) {
      this.props.dispatch(setBuildingParkingDayConfig({
        'parkingDayConfig' :[...draftBuildingData.parkingDayConfigs],
        'isCanSave' : true,
      }));
    }

    this.setState({
      'loading' : false,
    });
  }


  handleSplitTime = (time) => {
    const newTime = time.split('T')[1].split(':');

    return `${newTime[0]}:${newTime[1]}`;
  }

  handleSaveDraftData = () => {
    const { 
      buildingInformation, buildingParkingFeeModelCar, buildingParkingFeeModelMotorcycle, 
      redemptionModelInformation, configCommon, config, buildingContent, buildingTenant,
      buildingIotDevice, buildingParkingDayConfig,
    } = this.props;

    this.setState({
      'loading' : true,
    });

    if (this.props.match.path === commonConstant.pathEditDraftedBuilding) {      
      this.props.dispatch(fetchCreateDraftBuilding({
        'draftedBuildingID' : this.props.match.params.draftedBuildingID,
        'building' : buildingInformation.data,
        'buildingParkingFeeModelCar' : buildingParkingFeeModelCar.data ? buildingParkingFeeModelCar.data : null,
        'buildingParkingFeeModelMotorcycle' : buildingParkingFeeModelMotorcycle.data ? buildingParkingFeeModelMotorcycle.data : null ,                
        'buildingRedemptionModelCar' : redemptionModelInformation.data ? {
          'maximumRedemptionMinutes' : redemptionModelInformation.data.maximumRedemptionMinutesCar,
          'maximumRedemptionQuota' : redemptionModelInformation.data.maximumRedemptionQuotaCar,
          'redemptionModel' : redemptionModelInformation.data.redemptionModelCar,
        } : null,
        'buildingRedemptionModelMotorcycle' :  redemptionModelInformation.data ? {
          'maximumRedemptionMinutes' : redemptionModelInformation.data.maximumRedemptionMinutesMotorcycle,
          'maximumRedemptionQuota' : redemptionModelInformation.data.maximumRedemptionQuotaMotorcycle,
          'redemptionModel' : redemptionModelInformation.data.redemptionModelMotorcycle,
        } : null,
        'buildingConfigCommon' : configCommon.data ? configCommon.data : null,        
        'buildingConfigCar' : config.data ? {
          ...config.data.buildingConfigCar,
          'overnightTimeStart' : config.data.buildingConfigCar.overnightTimeStart ? `0001-01-01T${config.data.buildingConfigCar.overnightTimeStart}:00Z` : null,
          'overnightTimeEnd' : config.data.buildingConfigCar.overnightTimeEnd ? `0001-01-01T${config.data.buildingConfigCar.overnightTimeEnd}:00Z` : null,
        } : null,        
        'buildingConfigMotorcycle' : config.data ? {
          ...config.data.buildingConfigMotorcycle,
          'overnightTimeStart' : config.data.buildingConfigMotorcycle.overnightTimeStart ? `0001-01-01T${config.data.buildingConfigMotorcycle.overnightTimeStart}:00Z` : null,
          'overnightTimeEnd' : config.data.buildingConfigMotorcycle.overnightTimeEnd ? `0001-01-01T${config.data.buildingConfigMotorcycle.overnightTimeEnd}:00Z` : null,
        } : null,
        'buildingContentTH' : buildingContent.data ? buildingContent.data.buildingContentTH : null,    
        'buildingContentEN' : buildingContent.data ? buildingContent.data.buildingContentEN : null,
        'tenantMembers' : buildingTenant.data ? buildingTenant.data.tenantMemberData : null,   
        'tenants' : buildingTenant.data ? buildingTenant.data.tenantData : null,
        'buildingIotDevices' : buildingIotDevice.data ? buildingIotDevice.data.buildingIotDevices : null,
        'parkingDayConfigs' :  buildingParkingDayConfig.data ? buildingParkingDayConfig.data.parkingDayConfig : null,              
      }));
    } else {
      this.props.dispatch(fetchCreateDraftBuilding({
        'building' : buildingInformation.data,
        'buildingParkingFeeModelCar' : buildingParkingFeeModelCar.data ? buildingParkingFeeModelCar.data : null,
        'buildingParkingFeeModelMotorcycle' : buildingParkingFeeModelMotorcycle.data ? buildingParkingFeeModelMotorcycle.data : null ,                
        'buildingRedemptionModelCar' : redemptionModelInformation.data ? {
          'maximumRedemptionMinutes' : redemptionModelInformation.data.maximumRedemptionMinutesCar,
          'maximumRedemptionQuota' : redemptionModelInformation.data.maximumRedemptionQuotaCar,
          'redemptionModel' : redemptionModelInformation.data.redemptionModelCar,
        } : null,
        'buildingRedemptionModelMotorcycle' :  redemptionModelInformation.data ? {
          'maximumRedemptionMinutes' : redemptionModelInformation.data.maximumRedemptionMinutesMotorcycle,
          'maximumRedemptionQuota' : redemptionModelInformation.data.maximumRedemptionQuotaMotorcycle,
          'redemptionModel' : redemptionModelInformation.data.redemptionModelMotorcycle,
        } : null,
        'buildingConfigCommon' : configCommon.data ? configCommon.data : null,        
        'buildingConfigCar' : config.data ? {
          ...config.data.buildingConfigCar,
          'overnightTimeStart' : config.data.buildingConfigCar.overnightTimeStart ? `0001-01-01T${config.data.buildingConfigCar.overnightTimeStart}:00Z` : null,
          'overnightTimeEnd' : config.data.buildingConfigCar.overnightTimeEnd ? `0001-01-01T${config.data.buildingConfigCar.overnightTimeEnd}:00Z` : null,
        } : null,        
        'buildingConfigMotorcycle' : config.data ? {
          ...config.data.buildingConfigMotorcycle,
          'overnightTimeStart' : config.data.buildingConfigMotorcycle.overnightTimeStart ? `0001-01-01T${config.data.buildingConfigMotorcycle.overnightTimeStart}:00Z` : null,
          'overnightTimeEnd' : config.data.buildingConfigMotorcycle.overnightTimeEnd ? `0001-01-01T${config.data.buildingConfigMotorcycle.overnightTimeEnd}:00Z` : null,
        } : null,
        'buildingContentTH' : buildingContent.data ? buildingContent.data.buildingContentTH : null,    
        'buildingContentEN' : buildingContent.data ? buildingContent.data.buildingContentEN : null,
        'tenantMembers' : buildingTenant.data ? buildingTenant.data.tenantMemberData : null,   
        'tenants' : buildingTenant.data ? buildingTenant.data.tenantData : null,      
        'buildingIotDevices' : buildingIotDevice.data ? buildingIotDevice.data.buildingIotDevices : null,
        'parkingDayConfigs' :  buildingParkingDayConfig.data ? buildingParkingDayConfig.data.parkingDayConfig : null,   
      }));
    }
  }

    handleSection = (sectionName) => {      
      this.setState({
        'section': sectionName,
      });
    }

    handleIsCanSaveDraft = () => {      
      const { buildingInformation } = this.props;
  
      if (this.props.match.path === commonConstant.pathCreateBuilding) {
        if (buildingInformation.data && buildingInformation.data.buildingRefNo && buildingInformation.data.buildingName){ 
          return true;
        } else {
          return false;
        }
      } else {
        return true;
      }
    }

    handleSectionName = () => {
      const { section } = this.state;

      switch (section) {
        case 'building-information':
          return 'Building';
        case 'parking-model-car':
          return 'Parking model car';
        case 'parking-model-motorcycle':
          return 'Parking model motorcycle';
        case 'redemption-model':
          return 'Redemption model';
        case 'config-common':
          return 'Config common';
        case 'config':
          return 'Config';
        case 'content':
          return 'Content';
        case 'tenant':
          return 'Tenant';
        case 'iot-devices':
          return 'Iot devices';
        case 'parking-day-config':
          return 'Parking day config';

        default:
          break;
      }
    }

    handleCreateBuildingContent = () => {
      // TODO : change it follow content component 
      const { section } = this.state;

      switch (section) {
        case 'building-information':
          return (
            <div>
              <BuildingInformation/>
              <div className="btn-next-container">
                <Button onClick={() => this.handleSection('parking-model-car')} className="btn-primary btn-next">ถัดไป</Button>
              </div>          
            </div>
          );
        case 'parking-model-car':
          return (
            <div>
              <ParkingModel model={commonConstant.vehicleTypeCar} />
              <div className="btn-next-container">
                <Button onClick={() => this.handleSection('parking-model-motorcycle')} className="btn-primary btn-next">ถัดไป</Button>
              </div>
            </div>
          );
        case 'parking-model-motorcycle':
          return (
            <div>
              <ParkingModel model={commonConstant.vehicleTypeMotorcycle} />
              <div className="btn-next-container">
                <Button onClick={() => this.handleSection('redemption-model')} className="btn-primary btn-next">ถัดไป</Button>
              </div>
            </div>
          );
        case 'redemption-model':
          return (
            <div>
              <RedemptionModelInformation/>
              <div className="btn-next-container">
                <Button onClick={() => this.handleSection('config-common')} className="btn-primary btn-next">ถัดไป</Button>
              </div>
            </div>
          );
        case 'config-common':
          return (
            <div>
              <ConfigCommon/>
              <div className="btn-next-container">
                <Button onClick={() => this.handleSection('config')} className="btn-primary btn-next">ถัดไป</Button>
              </div>
            </div>
          );
        case 'config':
          return (
            <div>
              <Config/>
              <div className="btn-next-container">
                <Button onClick={() => this.handleSection('content')} className="btn-primary btn-next">ถัดไป</Button>
              </div>
            </div>
          );
        case 'content':
          return (
            <div>
              <BuildingContent/>
              <div className="btn-next-container">
                <Button onClick={() => this.handleSection('tenant')} className="btn-primary btn-next">ถัดไป</Button>
              </div>
            </div>
          );
        case 'tenant':
          return (
            <div>
              <BuildingTenant/>
              <div className="btn-next-container">
                <Button onClick={() => this.handleSection('iot-devices')} className="btn-primary btn-next">ถัดไป</Button>
              </div>
            </div>
          );
        case 'iot-devices':
          return <div>
            <BuildingIotDevice/>
            <div className="btn-next-container">
              <Button onClick={() => this.handleSection('parking-day-config')} className="btn-primary btn-next">ถัดไป</Button>
            </div>
          </div>;
        case 'parking-day-config':
          return (
            <div>
              <BuildingParkingDayConfig/>
              <div className="btn-next-container">
                <Button onClick={() => this.setState({ 'showOnboardModal': true })} className="btn-primary btn-next" disabled={!this.handleIsCanOnboard()}>ส่งข้อมูล</Button>
              </div>
            </div>
          );

        default:
          break;
      }
    }

    handleBuildingName = () => {
      const { buildingInformation } = this.props;  
      
      if (buildingInformation.data && buildingInformation.data.buildingName){ 
        return buildingInformation.data.buildingName;
      } else {
        return 'Building name';
      }
    }


    handleBuildingRefNo = () => {
      const { buildingInformation } = this.props;  
      
      if (buildingInformation.data && buildingInformation.data.buildingRefNo){ 
        return buildingInformation.data.buildingRefNo;
      } else {
        return 'Building name';
      }
    }
    render() {
      const { 
        buildingInformation, buildingParkingFeeModelCar, buildingParkingFeeModelMotorcycle, 
        redemptionModelInformation, configCommon, config, buildingContent, buildingTenant,
        buildingIotDevice, buildingParkingDayConfig,
      } = this.props;
      const { loading, showOnboardModal } = this.state;
      
      if (loading) {
        return <Loading/>;
      }

      return (        
        <div className="CreateBuilding layout-box-page-without-margin">
          <Modal
            show={showOnboardModal ? true : false}            
            headerTemplate="a"            
          >
            <div className="onboard-building-modal">
              <div className="onboard-building-modal-title">คุณพร้อมที่จะส่งข้อมูลเลยหรือไม่</div>
              <div className="onboard-building-modal-description">
                <div className="line-1">หากคุณส่งข้อมูลข้อมูลในบางส่วนจะไม่สามารถเเก้ไขผ่านหน้าเว็บได้อีก</div>
                <div className="line-2">1. Iot Devices</div>
                <div className="line-3">2. Building ref no</div>
                <div className="onboard-note">*สามารถกด บันทึกดราฟ เพื่อเปลี่ยนแปลงข้อมูลที่หลังได้</div>
                <div className="button-container">
                  <Button onClick={() => this.setState({ 'showOnboardModal': false })} className="btn-sixtary cancel-button">ยกเลิก</Button>
                  <Button onClick={() => this.handleOnboardBuilding()} className="btn-primary send-data-button" disabled={!this.handleIsCanOnboard()}>ส่งเลย</Button>
                </div>
              </div>
            </div>
          </Modal>
          <div className="create-building-navbar">
            <div className="navbar-header" >
              <div className="building-name">{this.handleBuildingName()}</div>
              <div className="building-ref-number">{this.handleBuildingRefNo()}</div>
            </div>
            <div className="navbar-item" onClick={() => this.handleSection('building-information')}>
              <span className={`icon ${buildingInformation.data && buildingInformation.data.isCanSave ? 'icon-check' : 'icon-warning'}`} />
              <span className="navbar-item-text">Building information</span>
            </div>
            <div className="navbar-item" onClick={() => this.handleSection('parking-model-car')}>
              <span className={`icon ${buildingParkingFeeModelCar.data && buildingParkingFeeModelCar.data.isCanSave ? 'icon-check' : 'icon-warning'}`} />
              <span className="navbar-item-text">Parking Model Car</span>
            </div>
            <div className="navbar-item" onClick={() => this.handleSection('parking-model-motorcycle')}>
              <span className={`icon ${buildingParkingFeeModelMotorcycle.data && buildingParkingFeeModelMotorcycle.data.isCanSave ? 'icon-check' : 'icon-warning'}`} />
              <span className="navbar-item-text">Parking Model Motorcycle</span>
            </div>
            <div className="navbar-item" onClick={() => this.handleSection('redemption-model')}>
              <span className={`icon ${redemptionModelInformation.data && redemptionModelInformation.data.isCanSave ? 'icon-check' : 'icon-warning'}`} />
              <span className="navbar-item-text">Redemption model information</span>
            </div>
            <div className="navbar-item" onClick={() => this.handleSection('config-common')}>
              <span className={`icon ${configCommon.data && configCommon.data.isCanSave ? 'icon-check' : 'icon-warning'}`} />
              <span className="navbar-item-text">Config common</span>
            </div>
            <div className="navbar-item" onClick={() => this.handleSection('config')}>
              <span className={`icon ${config.data && config.data.isCanSave ? 'icon-check' : 'icon-warning'}`} />
              <span className="navbar-item-text">Config (Car / Motorcycle)</span>
            </div>
            <div className="navbar-item" onClick={() => this.handleSection('content')}>
              <span className={`icon ${buildingContent.data && buildingContent.data.isCanSave ? 'icon-check' : 'icon-warning'}`} />
              <span className="navbar-item-text">Content</span>
            </div>
            <div className="navbar-item" onClick={() => this.handleSection('tenant')}>
              <span className={`icon ${buildingTenant.data && buildingTenant.data.isCanSave ? 'icon-check' : 'icon-warning'}`} />
              <span className="navbar-item-text">Tenant</span>
            </div>
            <div className="navbar-item" onClick={() => this.handleSection('iot-devices')}>
              <span className={`icon ${buildingIotDevice.data && buildingIotDevice.data.isCanSave ? 'icon-check' : 'icon-warning'}`} />
              <span className="navbar-item-text">Iot Devices</span>
            </div>
            <div className="navbar-item" onClick={() => this.handleSection('parking-day-config')}>
              <span className={`icon ${buildingParkingDayConfig.data && buildingParkingDayConfig.data.isCanSave ? 'icon-check' : 'icon-warning'}`} />
              <span className="navbar-item-text">Parking day config</span>
            </div>
          </div>
          <div className="create-building-content-container">
            <div className="create-building-header">
              <div className="create-building-title">{this.handleSectionName()}</div>
              <div className="create-building-button-container">
                <div className="draft-button-container">
                  <Button onClick={() => this.handleSaveDraftData()} className="btn-sixtary draft-button" disabled={!this.handleIsCanSaveDraft()}>บันทึกดราฟ</Button>
                </div>
                <Button onClick={() => this.setState({ 'showOnboardModal': true })} className="btn-primary send-data-button" disabled={!this.handleIsCanOnboard()}>ส่งข้อมูล</Button>
              </div>
            </div>
            <div className="create-building-content">
              {
                this.handleCreateBuildingContent()
              }
            </div>
          </div>
        </div>
      );
    }
}

const mapStateToProps = ({ 
  buildingInformation,
  buildingParkingFeeModelCar, 
  buildingParkingFeeModelMotorcycle, 
  redemptionModelInformation,
  configCommon,
  config,
  buildingContent,
  buildingTenant,
  buildingIotDevice,
  buildingParkingDayConfig,
  getDraftBuilding,
  createDraftBuilding,
  createBuilding,
}) => ({
  buildingInformation, 
  buildingParkingFeeModelCar, 
  buildingParkingFeeModelMotorcycle, 
  redemptionModelInformation, 
  configCommon,
  config,
  buildingContent,
  buildingTenant,
  buildingIotDevice,
  buildingParkingDayConfig,
  getDraftBuilding,
  createDraftBuilding,
  createBuilding,
});

export default connect(mapStateToProps)(CreateBuilding);

CreateBuilding.propTypes = {
  'dispatch' : PropTypes.func,
  'match' : PropTypes.shape({
    'path' : PropTypes.string,
    'params' : PropTypes.shape({  
      'draftedBuildingID' : PropTypes.string,
    }),
  }),    
  'buildingInformation' : PropTypes.shape({
    'data': PropTypes.shape({
      'buildingRefNo': PropTypes.string,
      'buildingName': PropTypes.string,
      'buildingCompanyName': PropTypes.string,
      'buildingTaxID': PropTypes.string,
      'buildingPOSID': PropTypes.string,
      'buildingAddress': PropTypes.string,
      'buildingContactName': PropTypes.string,
      'buildingContactNumber': PropTypes.string,
      'buildingEmergencyContactNumber': PropTypes.string,
      'buildingContactEmail': PropTypes.string,
      'buildingMerchantID': PropTypes.string,
      'buildingDashboardURL': PropTypes.string,
      'buildingVatRatePercentage': PropTypes.number,
      'isCanSave' : PropTypes.bool,
    }),
  }),
  'buildingParkingFeeModelCar': PropTypes.shape({
    'data': PropTypes.shape({
      'isCanSave' : PropTypes.bool,
    }),
  }),
  'buildingParkingFeeModelMotorcycle': PropTypes.shape({
    'data': PropTypes.shape({
      'isCanSave' : PropTypes.bool,
    }),
  }),
  'redemptionModelInformation': PropTypes.shape({
    'data': PropTypes.shape({
      'maximumRedemptionMinutesCar' : PropTypes.number,
      'maximumRedemptionQuotaCar' : PropTypes.number,
      'maximumRedemptionMinutesMotorcycle' : PropTypes.number,
      'maximumRedemptionQuotaMotorcycle' : PropTypes.number,
      'redemptionModelCar' : PropTypes.string,
      'redemptionModelMotorcycle' : PropTypes.string,
      'isCanSave' : PropTypes.bool,
    }),
  }),
  'configCommon': PropTypes.shape({
    'data': PropTypes.shape({
      'buildingConfigCar' : PropTypes.shape({}),
      'buildingConfigMotorcycle' : PropTypes.shape({}),
      'isCanSave' : PropTypes.bool,
    }),
  }),
  'config': PropTypes.shape({
    'data': PropTypes.shape({
      'buildingConfigCar' : PropTypes.shape({
        'overnightTimeStart': PropTypes.string,
        'overnightTimeEnd': PropTypes.string,
      }),
      'buildingConfigMotorcycle' : PropTypes.shape({
        'overnightTimeStart': PropTypes.string,
        'overnightTimeEnd': PropTypes.string,
      }),
      'isCanSave' : PropTypes.bool,
    }),
  }),
  'buildingContent': PropTypes.shape({
    'data': PropTypes.shape({
      'buildingContentTH' : PropTypes.shape({}),
      'buildingContentEN' : PropTypes.shape({}),
      'isCanSave' : PropTypes.bool,
    }),
  }),
  'buildingTenant': PropTypes.shape({
    'data': PropTypes.shape({
      'tenantMemberData' : PropTypes.array,
      'tenantData' : PropTypes.array,
      'isCanSave' : PropTypes.bool,
    }),
  }),
  'buildingIotDevice': PropTypes.shape({
    'data': PropTypes.shape({
      'buildingIotDevices' : PropTypes.array,    
      'isCanSave' : PropTypes.bool,
    }),
  }),
  'buildingParkingDayConfig': PropTypes.shape({
    'data': PropTypes.shape({
      'parkingDayConfig' : PropTypes.array,
      'isCanSave' : PropTypes.bool,
    }),
  }),
  'createDraftBuilding' : PropTypes.shape({
    'status': PropTypes.number,
    'type': PropTypes.string, 
    'data' : PropTypes.shape({
      'draftedBuildingID' : PropTypes.string,
    }),
  }),
  'createBuilding' : PropTypes.shape({
    'status': PropTypes.number,
    'type': PropTypes.string,   
  }),
  'getDraftBuilding' : PropTypes.shape({
    'status': PropTypes.number,
    'type': PropTypes.string,    
    'data' : PropTypes.arrayOf(PropTypes.shape({
      'importDataDraftedBuilding' : PropTypes.shape({
        'building' : PropTypes.shape({}),
        'buildingParkingFeeModelCar' : PropTypes.shape({}),
        'buildingParkingFeeModelMotorcycle': PropTypes.shape({}),
        'buildingRedemptionModelCar' : PropTypes.shape({
          'maximumRedemptionMinutes': PropTypes.number,
          'maximumRedemptionQuota': PropTypes.number,
          'redemptionModel': PropTypes.string,
        }),
        'buildingRedemptionModelMotorcycle' : PropTypes.shape({
          'maximumRedemptionMinutes': PropTypes.number,
          'maximumRedemptionQuota': PropTypes.number,
          'redemptionModel': PropTypes.string,
        }),
        'buildingConfigCommon' : PropTypes.shape({}),
        'buildingConfigCar': PropTypes.shape({
          'overnightTimeStart' : PropTypes.string,
          'overnightTimeEnd' : PropTypes.string,
        }),
        'buildingConfigMotorcycle' : PropTypes.shape({
          'overnightTimeStart' : PropTypes.string,
          'overnightTimeEnd' : PropTypes.string,
        }),
        'buildingContentTH' : PropTypes.shape({}),
        'buildingContentEN' : PropTypes.shape({}),
        'tenantMembers' : PropTypes.array,
        'tenants' : PropTypes.array,
        'buildingIotDevices' : PropTypes.array, 
        'parkingDayConfigs' : PropTypes.array,
      }),
    })),
  }),
};
